import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

/**
 * Layout wrapping the unauthenticated routes (login, register, password reset).
 * If the user already has a valid session we send them to the dashboard root.
 */
export default function PublicLayout() {
 // Select primitive fields directly so the selector returns a stable value;
 // calling `isAuthenticated()` inside the selector returns a new boolean each
 // render in some zustand patterns and can trigger an infinite loop.
 const accessToken = useAuthStore((s) => s.accessToken);
 const user = useAuthStore((s) => s.user);
 const isAuthenticated = Boolean(accessToken && user);

 if (isAuthenticated) {
 return <Navigate to="/" replace />;
 }
 return (
 <main className="flex min-h-screen items-center justify-center bg-background px-4 py-12">
 <div className="w-full max-w-md rounded-2xl surface p-8 shadow-sm">
 <Outlet />
 </div>
 </main>
 );
}
